import { message } from "antd";
import { get } from "lodash";
import moment from "moment";
import axios from "axios";
import FileSaver from "file-saver";

const formatSnapShot = snapshot => {
  const returnArray = [];

  snapshot.forEach(childSnapshot => {
    const item = childSnapshot.data();
    item.id = childSnapshot.id;

    returnArray.push(item);
  });

  return returnArray;
};

const serializeObject = obj => {
  return Object.keys(obj)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
    .join("&");
};

const sendNotification = async ({ userId, message, actionTo, userToken }) => {
  try {
    const notification = await axios.post(
      "https://fcm.googleapis.com/fcm/send",
      {
        notification: {
          title: "Chazki",
          body: message,
          click_action: actionTo,
          icon:
            "https://is4-ssl.mzstatic.com/image/thumb/Purple128/v4/55/41/12/55411208-1e13-19ad-6c44-1aff43bbf149/source/512x512bb.jpg",
        },
        to: userToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${process.env.REACT_APP_NOTIFICATION_TOKEN}`,
        },
      }
    );

    console.log("PUSH response", notification);
  } catch (e) {
    console.log("Cannot send the push notification", e);
  }
};

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = file => {
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    message.error("¡Sólo puedes subir archivos JPG, PNG o WEBP!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("¡La imagen debe ser menor a 2 MB!");
  }
  return isImage && isLt2M;
};

const uploadFile = (
  action, // NO
  data, // NO
  file, // YES
  filename, // NO
  onError, // YES
  onProgress, // YES
  onSuccess, // YES
  firebase,
  key
) => {
  const task = firebase.refStorage.child(key).put(file);

  task.on(
    "state_changed",
    function progress(snapshot) {
      const percentage =
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      onProgress({ percent: percentage });
    },
    err => {
      console.log("error on upload", err);
      return onError();
    },
    () => {
      task.snapshot.ref.getDownloadURL().then(downloadURL => {
        console.log("Upload has completed");
        onSuccess({ file: downloadURL });
      });
    }
  );
};

const onFileUpload = (info, onUpload, done) => {
  const {
    file: { status },
  } = info;

  if (status === "uploading") {
    onUpload();
  }

  if (status === "done") {
    done();
  }
};

const normFile = e => {
  console.log("ER", e);
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList.map(el => ({ ...el, url: get(el, "response.file") }));
};

const formatFileArray = arrayFile =>
  (arrayFile || []).map(i => ({
    name: i.name,
    uid: i.uid,
    status: "done",
    url: i.url ? i.url : get(i, "response.file"),
  }));

const disabledPast = current =>
  current &&
  current <
    moment()
      .subtract(1, "days")
      .endOf("day");

const disabledFuture = current =>
  current &&
  current >
    moment()
      .subtract(1, "days")
      .endOf("day");

const downloadString = (tableHeaders, dataArrays, fileName, delimeter) => {
  const strArray = [tableHeaders.join(delimeter)];

  dataArrays.forEach(dataArray => {
    const s = dataArray.join(delimeter);
    strArray.push(s);
  });

  const str = strArray.join("\n");

  const blob = new Blob([str], {
    type: "text/plain;charset=utf-8",
  });
  FileSaver.saveAs(blob, fileName);
};

const getBase64Promise = img => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

const fileNameStamp = (name = "", extension = "png") => {
  const date = new Date();
  date.setHours(date.getHours() - 5);

  const timestamp = date
    .toISOString()
    .replace(/:/g, "-")
    .replace(/\./g, "-");

  // Limpia espacios al inicio/final y reemplaza uno o más espacios por "_"
  const sanitizedName = name
    .trim()
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");

  return `${timestamp}_${sanitizedName}.${extension}`;
};

// Función para obtener la extensión a partir del mime type
const getExtensionFromMimeType = (mimeType = "") => {
  const map = {
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/webp": "webp",
  };

  return map[mimeType.toLowerCase()] || "png";
};

// Valida que el Data URL sea una imagen válida y no esté vacío
const validateBase64Image = dataUrl => {
  if (!dataUrl || typeof dataUrl !== "string") {
    throw new Error("La imagen está vacía.");
  }

  // Debe comenzar con data:image/
  if (!dataUrl.startsWith("data:image/")) {
    throw new Error("El archivo no es una imagen válida.");
  }

  // Extraer la parte base64
  const base64Data = dataUrl.split(",")[1];

  if (!base64Data || base64Data.length === 0) {
    throw new Error("La imagen no contiene datos.");
  }

  // Verificar que no sea una imagen de 0 bytes
  // Cada 4 caracteres base64 representan 3 bytes
  const sizeInBytes = Math.floor((base64Data.length * 3) / 4);

  if (sizeInBytes <= 0) {
    throw new Error("La imagen tiene tamaño 0 KB.");
  }

  return sizeInBytes;
};

// Sube una imagen en formato Data URL a Firebase Storage
const uploadBase64Image = async (
  firebase,
  base64Image,
  folderPath,
  fullName
) => {
  // Validar que la imagen sea correcta
  validateBase64Image(base64Image);

  // Obtener mime type y extensión
  const mimeType = base64Image.match(
    /^data:(image\/[a-zA-Z0-9+.-]+);base64,/
  )[1];
  const extension = getExtensionFromMimeType(mimeType);

  // Generar nombre con extensión
  const fileName = fileNameStamp(fullName, extension);
  const storagePath = `${folderPath}/${fileName}`;

  // Subir archivo
  const uploadTask = firebase.refStorage
    .child(storagePath)
    .putString(base64Image, "data_url");

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      snapshot => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log(`Subiendo ${fileName}: ${progress}%`);
      },
      error => reject(error),
      async () => {
        try {
          // Validar que el archivo realmente exista y no sea 0 bytes
          const metadata = await firebase.refStorage
            .child(storagePath)
            .getMetadata();

          if (!metadata.size || Number(metadata.size) <= 0) {
            throw new Error(`El archivo ${fileName} se subió con 0 bytes.`);
          }

          // Obtener URL
          const url = await firebase.refStorage
            .child(storagePath)
            .getDownloadURL();

          resolve(url);
        } catch (error) {
          reject(error);
        }
      }
    );
  });
};

const getDeviceInfo = () => {
  return {
    browser: {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      vendor: navigator.vendor
    },
    hardware: {
      hardwareConcurrency:
        navigator.hardwareConcurrency,
      deviceMemory:
        navigator.deviceMemory,
      maxTouchPoints:
        navigator.maxTouchPoints
    },
    screen: {
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      colorDepth: window.screen.colorDepth,
      pixelRatio: window.devicePixelRatio
    }
  };

};

export {
  formatSnapShot,
  serializeObject,
  sendNotification,
  getBase64,
  beforeUpload,
  formatFileArray,
  normFile,
  disabledFuture,
  disabledPast,
  onFileUpload,
  uploadFile,
  downloadString,
  getBase64Promise,
  uploadBase64Image,
  getDeviceInfo,
};
